<template>
  <div class="box-border has-background-white h-100-per" id="investmentSubBox">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardIndustry") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardIndustry") }}
      </p>
      <p
        class="pd-y-10 icon-color is-size-5 cr-pointer"
        @click="$emit('openModalInfo', 'tb')"
      >
        <i class="fas fa-question-circle"></i>
      </p>
    </div>
    <div v-if="Math.max(...businessTypeBarData) > 0" class="columns m-h-auto">
      <div class="column pd-20">
        <HorizontalBar
          :height="businessTypeBarX.length * 40"
          :width="450"
          :bgColor="'#00a79d'"
          :labels="businessTypeBarX"
          :numData="businessTypeBarData"
          :maxY="Math.max(...businessTypeBarData)"
          :tooltipsOpen="true"
          :tooltipsCompanyText="true"
        />
      </div>
    </div>
    <div
      v-else
      class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
    >
      <p>*** {{ $t("dashboard.notfound") }} ***</p>
    </div>
  </div>
</template>

<script>
import HorizontalBar from "../../charts/HorizontalBar";
export default {
  components: {
    HorizontalBar,
  },
  computed: {
    businessTypeBarX() {
      let labelX = [];
      for (
        let index = 0;
        index < this.$store.state.businessType.length;
        index++
      ) {
        let find = this.$store.getters.startupLists.find(
          (startup) =>
            startup.typeOfBusiness === this.$store.state.businessType[index].id
        );

        if (typeof find !== "undefined") {
          let name =
            this.$i18n.locale === "th"
              ? this.$store.state.businessType[index].name
              : this.$store.state.businessType[index].nameEN;
          labelX.push(name);
        }
        this.heightChart = index * 35;
      }

      return labelX;
    },
    user() {
      return this.$store.state.user;
    },
    businessTypeBarData() {
      let data = [];
      this.$store.state.businessType.map((item) => {
        let filter = this.$store.getters.startupLists.filter(
          (startup) => startup.typeOfBusiness === item.id
        );
        if (filter.length > 0) {
          data.push(filter.length);
        }
      });

      return data;
    },
  },
};
</script>